import { render, staticRenderFns } from "./DefaultCharts.component.vue?vue&type=template&id=d675670c&scoped=true&"
import script from "./DefaultCharts.component.vue?vue&type=script&lang=js&"
export * from "./DefaultCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCharts.component.vue?vue&type=style&index=0&id=d675670c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d675670c",
  null
  
)

export default component.exports